module.exports = __webpack_public_path__ + "img/live_weixin.5b15117f.5b15117f.png";